import { trackPlanTaskEvent } from './trackPlanTaskEvent';
import { PlanTaskAnalyticEvent, planTaskPluginMetadata } from '../consts';
import { PlanTaskReferencePickerPlugin } from '../types';

export const onRemove: PlanTaskReferencePickerPlugin['onRemove'] = (
  relationship,
) => {
  const removedEntity = relationship.entities.find(
    (entity) => entity.type !== planTaskPluginMetadata.type,
  );

  if (removedEntity) {
    trackPlanTaskEvent(PlanTaskAnalyticEvent.DELETE, removedEntity.type);
  }
};
